import { Tabs } from 'types/Tabs';
import ResumeContractRequest from './ResumeContractRequest';
import ContractRequestSigningPanel from './ContractRequestSigningPanel';
import {
  CampaignDetailModel,
  ContractDetailModel,
  EnvelopeSubmissionModelType,
} from '@urbanx/agx.campaigns.client';

interface ContractRequestInfoPanelProps {
  campaign: CampaignDetailModel;
  contract: ContractDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
  onPinnedContractChange: (contractId?: string) => void;
}

const ContractRequestInfoPanel = ({
  campaign,
  contract,
  currentTab,
  mobile = false,
  onPinnedContractChange,
}: ContractRequestInfoPanelProps) => {
  if (
    [EnvelopeSubmissionModelType.DocuSign, EnvelopeSubmissionModelType.Email].includes(
      contract.envelopeSubmission?.type ?? EnvelopeSubmissionModelType.Manual
    )
  ) {
    return (
      <ContractRequestSigningPanel
        campaign={campaign}
        currentTab={currentTab}
        mobile={mobile}
        onPinnedContractChange={onPinnedContractChange}
      />
    );
  } else {
    return (
      <ResumeContractRequest
        campaign={campaign}
        contract={contract}
        currentTab={currentTab}
        mobile={mobile}
      />
    );
  }
};

export default ContractRequestInfoPanel;
